import { MOOD_OPTIONS } from '../utils/constants';

export default function CheckInForm({ formData, onUpdateForm, onSubmit, loading }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.mood || !formData.thoughts.trim()) {
      alert('Please select a mood and share your thoughts.');
      return;
    }
    onSubmit(formData);
  };

  const getMoodSettings = (mood) => {
    switch (mood) {
      case 'great':
      case 'good':
        return { min: 1, max: 4, default: 2, label: 'Productive Energy', leftLabel: 'Calm', rightLabel: 'Active' };
      case 'okay':
        return { min: 4, max: 7, default: 5, label: 'Tension Level', leftLabel: 'Balanced', rightLabel: 'Tense' };
      case 'stressed':
        return { min: 7, max: 10, default: 8, label: 'Distress Level', leftLabel: 'Pressured', rightLabel: 'Overwhelmed' };
      case 'overwhelmed':
        return { min: 7, max: 10, default: 9, label: 'Distress Level', leftLabel: 'Pressured', rightLabel: 'Overwhelmed' };
      default:
        return { min: 1, max: 10, default: 5, label: 'Stress Level', leftLabel: 'Calm', rightLabel: 'Overwhelmed' };
    }
  };

  const handleMoodChange = (moodValue) => {
    onUpdateForm('mood', moodValue);
    const settings = getMoodSettings(moodValue);
    onUpdateForm('stress', settings.default);
  };

  const currentSettings = getMoodSettings(formData.mood);

  const handleStressChange = (e) => {
    onUpdateForm('stress', Number(e.target.value));
  };

  const handleThoughtsChange = (e) => {
    onUpdateForm('thoughts', e.target.value);
  };

  const handleDateChange = (e) => {
    onUpdateForm('date', e.target.value);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Date Selector */}
      <div>
        <label className="block text-lg font-semibold text-gray-700 mb-3">
          Check-in Date
        </label>
        <input
          type="date"
          value={formData.date}
          onChange={handleDateChange}
          max={new Date().toISOString().split('T')[0]}
          className="w-full px-4 py-2 border-2 border-gray-200 rounded-lg focus:border-purple-400 focus:outline-none bg-gray-50"
        />
      </div>

      {/* Mood Selector */}
      <div>
        <label className="block text-lg font-semibold text-gray-700 mb-3">
          How are you feeling?
        </label>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {MOOD_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => handleMoodChange(option.value)}
              className={`p-3 rounded-lg font-medium transition-all ${
                formData.mood === option.value
                  ? `${option.color} ring-2 ring-offset-2 ring-purple-400 scale-105`
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stress Slider */}
      <div>
        <label className="block text-lg font-semibold text-gray-700 mb-3">
          {currentSettings.label}: <span className="text-purple-600">{formData.stress}/10</span>
        </label>
        <input
          type="range"
          min={currentSettings.min}
          max={currentSettings.max}
          value={formData.stress}
          onChange={handleStressChange}
          className="w-full h-2 bg-gradient-to-r from-green-300 to-red-300 rounded-lg appearance-none cursor-pointer accent-purple-500"
        />
        <div className="flex justify-between text-xs text-gray-500 mt-2">
          <span>{currentSettings.leftLabel}</span>
          <span>{currentSettings.rightLabel}</span>
        </div>
      </div>

      {/* Thoughts Textarea */}
      <div>
        <label className="block text-lg font-semibold text-gray-700 mb-3">
          What's on your mind?
        </label>
        <textarea
          value={formData.thoughts}
          onChange={handleThoughtsChange}
          placeholder="Share your thoughts, feelings, or what's happening today..."
          maxLength={500}
          className="w-full h-32 p-4 border-2 border-gray-200 rounded-lg focus:border-purple-400 focus:outline-none resize-none bg-gray-50 placeholder-gray-400"
        />
        <p className="text-xs text-gray-500 mt-2">{formData.thoughts.length}/500</p>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={loading}
        className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold py-3 rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? 'Generating response...' : 'Get Support & Insights'}
      </button>
    </form>
  );
}
